export const isInstagramMobileWebView = () => {
  if (typeof navigator === "undefined") {
    return false;
  }

  const userAgent = navigator.userAgent || "";

  return (
    /Instagram/i.test(userAgent) &&
    /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent)
  );
};
